"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContextLegacyProvider = exports.useModalContextLegacy = exports.modalContextLegacy = void 0;
/**
 * LEGACY MODAL FLOW CONTEXT
 */
const react_1 = require("react");
exports.modalContextLegacy = (0, react_1.createContext)(null);
const useModalContextLegacy = () => {
    const ctx = (0, react_1.useContext)(exports.modalContextLegacy);
    if (!ctx) {
        throw new Error('No <ModalContextLegacy /> provider');
    }
    return ctx;
};
exports.useModalContextLegacy = useModalContextLegacy;
exports.ModalContextLegacyProvider = exports.modalContextLegacy.Provider;
